<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <!-- pageTab (s) -->
        <ul class="tabList pageTab">
          <li :class="{ on: tab }" @click="tab = !tab">렌탈</li>
          <li :class="{ on: !tab }" @click="tab = !tab">구매</li>
        </ul>
        <!-- pageTab (e) -->

        <section class="hr pt20 mb20">
          <select class="ipt" title="조회기간 선택" v-model="year" @change="changeYear">
            <option value="all" selected="selected">전체 기간</option>
            <option v-for="option in yearSelectOptions" :value="option" :key="option">{{ option }}년</option>
          </select>
        </section>

        <!-- 렌탈 -->
        <template v-if="tab">
          <section class="full mg0" v-if="rentalListShow == 'show'">
            <ul class="prdList line hr bbNone">
              <li v-for="(rentalOrder, index) in rentalOrderList" :key="index">
                <div class="block">
                  <div class="prdState">
                    <div>
                      <span class="inB">
                        <i>{{ rentalOrder.preorderDateStr | dateFormatter('.') }}</i>
                      </span>
                      <span class="inB" v-if="rentalOrder.preorderId != ''">
                        (주문번호 :
                        <i>{{ rentalOrder.preorderId }}</i>
                        )
                      </span>
                      <br />
                      <em class="state" :class="{ pointC1: rentalOrder.dispStatus == 'releaseIng' || rentalOrder.dispStatus == 'releaseComp' }">
                        {{ rentalOrder.dispStatusNm }}
                      </em>
                    </div>
                    <div class="ar">
                      <button
                        type="button"
                        class="btn_s s"
                        @click="$router.push({ name: 'myOrderListDetail', params: { preorderId: rentalOrder.preorderId } })"
                        v-if="rentalOrder.dispStatus != 'reqIng'"
                      >
                        주문상세보기
                      </button>
                    </div>
                  </div>

                  <div class="prdItem xs">
                    <div class="imgArea">
                      <span class="img imgCover">
                        <img
                          :src="rentalOrder.thumbnail ? rentalOrder.thumbnail : '/img/error_image.jpg'"
                          :alt="rentalOrder.productName"
                          onerror="this.src='/img/error_image.jpg';"
                        />
                      </span>
                    </div>
                    <div class="infoArea">
                      <div class="tit row2">
                        <span>{{ rentalOrder.productName }}</span>
                      </div>
                      <div class="txtItem">
                        <span>{{ rentalOrder.modelName }}</span>
                      </div>
                      <div class="price">
                        <span class="money">
                          월 렌탈료
                          <em>{{ rentalOrder.rentalAmount | currency }}</em>
                          원 x {{ rentalOrder.rentalPeriod }}개월
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="btnArea">
                  <button type="button" class="btn_l s" v-if="rentalOrder.isBtnType == 'ODST0002' && rentalOrder.saleType != 'RORT00IS'" @click="goContractPage(rentalOrder.preorderId)">
                    작성중인 계약서 이어하기
                  </button>
                  <button
                    type="button"
                    class="btn_l s"
                    v-if="rentalOrder.isBtnType == 'ODST0001'"
                    @click="goOrderPage(rentalOrder.productIndex, rentalOrder.prodCode, rentalOrder.prodColor, rentalOrder.preorderId)"
                  >
                    작성중인 주문서 이어하기
                  </button>
                  <button type="button" class="btn_s s" v-if="rentalOrder.isBtnType == 'ODST0003'" @click="goReviewPage(rentalOrder.productIndex)">
                    리뷰 작성하기
                  </button>
                </div>
              </li>
            </ul>
          </section>

          <section class="hr" v-if="rentalListShow == 'hide'">
            <div class="resultMsg noItem">
              <p class="copy">주문하신 상품이 없네요.</p>
              <button type="button" class="btn_l m" @click="$router.push('/product/category/9')">홈쇼핑 히트템 보러가기</button>
            </div>
          </section>

          <section class="hr" v-if="rentalListShow == ''"></section>
        </template>

        <!-- 구매 -->
        <template v-if="!tab">
          <section class="full mg0" v-if="purchaseListShow == 'show'">
            <ul class="prdList line hr bbNone">
              <li v-for="(purchaseOrder, index) in purchaseOrderList" :key="index">
                <div class="block">
                  <div class="prdState">
                    <div>
                      <span class="inB">
                        <i>{{ purchaseOrder.preorderDateStr | dateFormatter('.') }}</i>
                      </span>
                      <span class="inB">
                        (주문번호 :
                        <i>{{ purchaseOrder.preorderId }}</i>
                        )
                      </span>
                      <br />
                      <em class="state" :class="{ pointC1: purchaseOrder.dispStatus == 'releaseIng' }">{{ purchaseOrder.dispStatusNm }}</em>
                    </div>
                    <div class="ar">
                      <button
                        type="button"
                        class="btn_s s"
                        @click="$router.push({ name: 'myOrderListDetail', params: { preorderId: purchaseOrder.preorderId } })"
                      >
                        주문상세보기
                      </button>
                    </div>
                  </div>

                  <div class="prdItem xs">
                    <div class="imgArea">
                      <span class="img">
                        <img
                          :src="purchaseOrder.thumbnail ? purchaseOrder.thumbnail : '/img/error_image.jpg'"
                          :alt="purchaseOrder.productName"
                          onerror="this.src='/img/error_image.jpg';"
                        />
                      </span>
                    </div>
                    <div class="infoArea">
                      <div class="tit row2">
                        <span>{{ purchaseOrder.productName }}</span>
                      </div>
                      <div class="txtItem">
                        <span>{{ purchaseOrder.modelName }}</span>
                      </div>
                      <div class="price">
                        <span class="money">
                          <em>{{ purchaseOrder.onePayAmount | currency }}</em>
                          원
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="btnArea">
                  <button
                    type="button"
                    class="btn_s s"
                    v-if="purchaseOrder.isBtnType == 'ODST0003'"
                    @click="goReviewPage(purchaseOrder.productIndex)"
                  >
                    리뷰 작성하기
                  </button>
                </div>
              </li>
            </ul>
          </section>

          <section class="hr" v-if="purchaseListShow == 'hide'">
            <div class="resultMsg noItem">
              <p class="copy">주문하신 상품이 없네요.</p>
              <button type="button" class="btn_l m" @click="$router.push('/product/category/9')">홈쇼핑 히트템 보러가기</button>
            </div>
          </section>

          <section class="hr" v-if="purchaseListShow == ''"></section>
        </template>

        <CommonBanner></CommonBanner>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>

    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import CommonBanner from '@/components/banner/CommonBanner';
import MessagePop from '@/components/popup/MessagePop';

export default {
  name: 'GuestOrder',
  components: {
    CommonBanner,
    MessagePop,
  },
  data() {
    return {
      headerTitle: '주문배송조회',
      msg: null,
      messagePop: false,

      tab: true,
      rentalOrderList: [],
      purchaseOrderList: [],

      rentalListShow: '',
      purchaseListShow: '',

      yearSelectOptions: [],
      year: 'all',
    };
  },
  mounted() {
    if (this.$route.params.tab == false) this.tab = false;
    console.log(this.$refs);
    this.$refs.header.loadingStart();
    this.selectYearSelectOptions();
    this.selectServiceAuthMyRentalList();
    this.selectServiceAuthMyOnepayRentalList();
  },
  methods: {
    selectYearSelectOptions() {
      const fullYear = new Date().getFullYear();

      for (let i = fullYear; i >= fullYear - 4; i--) {
        this.yearSelectOptions.push(i);
      }
    },
    changeYear() {
      this.selectServiceAuthMyRentalList();
      this.selectServiceAuthMyOnepayRentalList();
    },
    selectServiceAuthMyRentalList() {
      ApiService.service('GET', '/service/auth/myRentalList/' + this.year)
        .then(({ data }) => {
          console.log(data);
          this.rentalOrderList = data.result;

          if (this.rentalOrderList.length > 0) {
            this.rentalListShow = 'show';
          } else {
            this.rentalListShow = 'hide';
          }
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.$refs.header.loadingEnd();
        });
    },
    selectServiceAuthMyOnepayRentalList() {
      ApiService.service('GET', '/service/auth/myOnepayRentalList/' + this.year)
        .then(({ data }) => {
          console.log(data);
          this.purchaseOrderList = data.result;

          if (this.purchaseOrderList.length > 0) {
            this.purchaseListShow = 'show';
          } else {
            this.purchaseListShow = 'hide';
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    // 작성중인 계약서 이어하기
    goContractPage(preorderId) {
      let paramObj = {
        request: {
          orderCommInfo: {
            orderId: preorderId,
          },
          selectAgreeInfo: {
            agreeAppPush: null,
          },
          payInfo: {
            couponTitle: null,
          },
        },
      };
      this.$router.push({ name: 'memberStep5', params: { paramObj: paramObj } });
    },
    // 작성중인 주문서 이어하기
    goOrderPage(productIndex, prodCode, prodColor, orderId) {
      //this.$router.push({ path: '/order/rental/member/memberMain/' + productIndex, query: { internalProdCode: prodCode } });
      this.$router.push({
        name: 'memberMain',
        params: {
          productCode: productIndex,
          internalProdCode: prodCode,
          colorCode: prodColor,
          orderId: orderId,
        },
      });
    },
    // 리뷰 작성하기 이동
    goReviewPage(productIndex) {
      if (productIndex === 0) {
        this.msg = '리뷰 작성할 수 없는 상품입니다.';
        this.messagePop = true;
      } else {
        this.$router.push({ name: 'myReview' });
        // this.$router.push({ path: '/product/category/detail/' + productIndex, query: { section: 'review' } });
      }
    },
    close() {
      this.messagePop = false;
    },
  },
};
</script>
